import axios from '~src/utils/axios'
import { API_LIVE_URL } from '~src/utils/constant';

export const getMatchLive = async (apiLiveUrl: any | null, sportType = 'football', siteName = 'xoilacz') => {
  return await axios.get(`${apiLiveUrl ? apiLiveUrl : API_LIVE_URL}/v1/${sportType}/${siteName}/match/live`);
};

export const getMatchFootballLive = async (apiLiveUrl: any | null, siteName = 'xoilacz') => {
  return await axios.get(`${apiLiveUrl ? apiLiveUrl : API_LIVE_URL}/v1/football/${siteName}/match/live`);
};

export const getMatchBasketballLive = async (apiLiveUrl: any, siteName = 'xoilacz') => {
  return await axios.get(`${apiLiveUrl ? apiLiveUrl : API_LIVE_URL}/v1/basketball/${siteName}/match/live`);
};
